// Copyright (c) 2016 Deere & Company

import {updateClaimModalMode, updateCreateClaimModalVisibility} from './create-claim-modal-visibility';
import actions from '../../../action-list';
import {createClaim} from './validate-claim';
import {getUpdatedClaim} from '../services/update-maintenance-plan-claim';
import {isActionResetFormValidation} from '../../../shared/services/claim-shared-helper';

export const updateSelectedAction = selectedAction =>

    (dispatch, getState) => {

        const updatedClaim = getUpdatedClaim(getState().claims.maintenancePlan.claim, selectedAction);

        const updateModalVisibility = () => {

            updateClaimModalMode('CREATE')(dispatch);
            updateCreateClaimModalVisibility(true)(dispatch);

        };

        const updateIsEditable = () => {

            dispatch({
                type: actions.REVISE_CLAIM_MAINTENANCE_PLAN
            });

            dispatch({
                isEditable: true,
                type: actions.UPDATE_CLAIM_MAINTENANCE_PLAN_IS_EDITABLE
            });

        };

        if (isActionResetFormValidation(selectedAction.id)) {

            dispatch({
                type: actions.RESET_CLAIM_MAINTENANCE_PLAN_FORM_VALIDATION
            });

        }

        const selectedActionIdTypes = {
            CRT: updateModalVisibility,
            REVISE: updateIsEditable
        };

        const updateType = selectedActionIdTypes[selectedAction.id];

        return updateType ? updateType() : createClaim(updatedClaim)(dispatch, getState);

    };



// WEBPACK FOOTER //
// ./src/claim/marketing/maintenance-plan/action-creators/update-selected-action.js